import {
  CLEAR_NEW_INFO,
  NACHA_VALIDATION_FAILURE,
  RESET_BANNER_ERRORS,
  RESET_FORM_STATE,
  RESET_STATE,
  SET_ACTIVE_ACCOUNT_FORM,
  SET_EXISTING_INFO,
  SET_INPUT,
  SET_INPUT_ERROR,
  SET_IS_SOURCE_DRAWER_OPEN,
  SET_USE_EXISTING,
  SET_VALIDATE_ROUTING_ERROR,
  UPDATE_FORM_ERRORS,
  VALIDATE_ROUTING,
  VALIDATE_ROUTING_FAILURE,
  VALIDATE_ROUTING_FLEX_DRAFT,
  VALIDATE_ROUTING_SUCCESS,
} from './constants';

export function clearNewInfo() {
  return { type: CLEAR_NEW_INFO };
}

export function nachaValidationFailure(bannerError) {
  return {
    payload: { bannerError },
    type: NACHA_VALIDATION_FAILURE,
  };
}

export function resetBannerErrors() {
  return { type: RESET_BANNER_ERRORS };
}

export function resetFormState({ form }) {
  return {
    payload: { form },
    type: RESET_FORM_STATE,
  };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function setActiveAccountForm({ form }) {
  return {
    payload: { form },
    type: SET_ACTIVE_ACCOUNT_FORM,
  };
}

export function setExistingInfo(existingAccountInformation, paymentType = 'otp') {
  return {
    payload: { existingAccountInformation, paymentType },
    type: SET_EXISTING_INFO,
  };
}

export function setInput({ field, value }) {
  return {
    payload: { field, value },
    type: SET_INPUT,
  };
}

export function setInputError({ activeAccountForm, field, value }) {
  return {
    payload: { activeAccountForm, field, value },
    type: SET_INPUT_ERROR,
  };
}

export function setIsSourceDrawerOpen(value) {
  return {
    payload: { value },
    type: SET_IS_SOURCE_DRAWER_OPEN,
  };
}

export function setUseExisting(value, paymentType = 'otp') {
  return {
    payload: { paymentType, value },
    type: SET_USE_EXISTING,
  };
}

export function setValidateRoutingError(value) {
  return {
    payload: { value },
    type: SET_VALIDATE_ROUTING_ERROR,
  };
}

export function updateFormErrors(payload) {
  return {
    payload,
    type: UPDATE_FORM_ERRORS,
  };
}

export function validateRouting(payload) {
  return {
    payload,
    type: VALIDATE_ROUTING,
  };
}

export function validateRoutingFailure() {
  return { type: VALIDATE_ROUTING_FAILURE };
}

export function validateRoutingFlexDraft(payload) {
  return {
    payload,
    type: VALIDATE_ROUTING_FLEX_DRAFT,
  };
}

export function validateRoutingSuccess(isValid) {
  return {
    payload: { isValid },
    type: VALIDATE_ROUTING_SUCCESS,
  };
}
